export default {
  text: 'Door deze website te gebruiken ga je akkoord met ons',
  cookie_policy: 'Cookiebeleid.',
  buttons: {
    accept: 'Accepteren',
    reject: 'Weigeren',
  },
};
